import { Component } from '@theme/component';

class ThorneJourney extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bindJourney();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bindJourney();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
  }

  bindJourney() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
    this.controller = new AbortController();
    this.track = this.querySelector('[data-journey-track]');
    this.chapters = [...this.querySelectorAll('[data-journey-chapter]')];
    if (!this.track || !this.chapters.length) return;
    this.previous = this.querySelector('[data-journey-prev]');
    this.next = this.querySelector('[data-journey-next]');
    this.rtl = getComputedStyle(this.track).direction === 'rtl';
    this.addEventListener('click', this.handleClick, { signal: this.controller.signal });
    this.track.addEventListener('scroll', this.queueSync, { passive: true, signal: this.controller.signal });
    this.track.addEventListener('keydown', this.handleKey, { signal: this.controller.signal });
    this.resizeObserver = new ResizeObserver(this.queueSync);
    this.resizeObserver.observe(this.track);
    for (const controls of this.querySelectorAll('[data-journey-controls]')) controls.hidden = false;
    this.syncState();
  }

  queueSync = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.syncState());
  };

  syncState() {
    const bounds = this.track.getBoundingClientRect();
    const edge = this.rtl ? bounds.right : bounds.left;
    let distance = Infinity;
    this.index = 0;
    this.chapters.forEach((chapter, index) => {
      const rect = chapter.getBoundingClientRect();
      const delta = Math.abs((this.rtl ? rect.right : rect.left) - edge);
      if (delta < distance) { distance = delta; this.index = index; }
    });
    const atStart = Math.abs(this.track.scrollLeft) < 2;
    const atEnd = Math.abs(this.track.scrollLeft) >= this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.previous) this.previous.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
  }

  goTo(index) {
    const chapter = this.chapters[Math.max(0, Math.min(index, this.chapters.length - 1))];
    const bounds = this.track.getBoundingClientRect();
    const target = chapter.getBoundingClientRect();
    const delta = this.rtl ? target.right - bounds.right : target.left - bounds.left;
    this.track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }

  handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button');
    if (!button || !this.contains(button)) return;
    if (button.matches('[data-journey-prev]')) this.goTo(this.index - 1);
    if (button.matches('[data-journey-next]')) this.goTo(this.index + 1);
  };

  handleKey = (event) => {
    if (event.target !== this.track) return;
    if (event.key === 'Home') { event.preventDefault(); this.goTo(0); }
    if (event.key === 'End') { event.preventDefault(); this.goTo(this.chapters.length - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); this.goTo(this.index + (this.rtl ? -1 : 1)); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.index + (this.rtl ? 1 : -1)); }
  };
}

if (!customElements.get('thorne-journey')) customElements.define('thorne-journey', ThorneJourney);
